import { Action } from '@ngrx/store';

import { Functionalities } from '@common/entities/functionalities.entity';

export enum FunctionalityActionTypes {
    SetFunctionalities = '[Function] Set',
    UnsetFunctionalities = '[Function] Unset'
}

export class SetFunctionalities implements Action {
    readonly type: FunctionalityActionTypes.SetFunctionalities = FunctionalityActionTypes.SetFunctionalities;
    constructor(public payload: Functionalities) {}
}

export class UnsetFunctionalities implements Action {
    readonly type: FunctionalityActionTypes.UnsetFunctionalities = FunctionalityActionTypes.UnsetFunctionalities;
}

export type FunctionalityAction = SetFunctionalities | UnsetFunctionalities;
